import type { ServiceDocument } from '@/types'

/**
 * Build the /request URL that prefills the booking form with this service
 * in the first service slot. Mirrors the link used by ServiceCard on the
 * all-services page so both entry points stay in sync.
 */
export function buildServiceBookingUrl(
  service: ServiceDocument & { id: string }
): string {
  const extra = service.serviceKey
    ? `sk=${encodeURIComponent(service.serviceKey)}`
    : `service=${encodeURIComponent(service.category)}`
  return `/request?offering=${service.id}&${extra}`
}
